/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CreateReportDefinitionMutationResponse, CreateReportDefinitionPathParams, CreateReportDefinition400 } from "../models/CreateReportDefinition";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createReportDefinition } from "../axios/createReportDefinition";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createReportDefinitionMutationKey = () => ["audit-reports-api", { url: '/report-definitions/:reportType' }] as const

export type CreateReportDefinitionMutationKey = ReturnType<typeof createReportDefinitionMutationKey>

export function createReportDefinitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = createReportDefinitionMutationKey()
        return mutationOptions<CreateReportDefinitionMutationResponse, ResponseErrorConfig<CreateReportDefinition400>, {reportType: CreateReportDefinitionPathParams["reportType"]}, TContext>({
          mutationKey,
          mutationFn: async({ reportType }) => {
            return createReportDefinition(reportType, config)
          },
        })

}

/**
 * @description Creates a new report definition from the latest blueprint version for the specified report type
 * @summary Create new report definition
 * {@link /report-definitions/:reportType}
 */
export function useCreateReportDefinition<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateReportDefinitionMutationResponse, ResponseErrorConfig<CreateReportDefinition400>, {reportType: CreateReportDefinitionPathParams["reportType"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createReportDefinitionMutationKey()

          const baseOptions = createReportDefinitionMutationOptions(config) as UseMutationOptions<CreateReportDefinitionMutationResponse, ResponseErrorConfig<CreateReportDefinition400>, {reportType: CreateReportDefinitionPathParams["reportType"]}, TContext>
          

          return useMutation<CreateReportDefinitionMutationResponse, ResponseErrorConfig<CreateReportDefinition400>, {reportType: CreateReportDefinitionPathParams["reportType"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateReportDefinitionMutationResponse, ResponseErrorConfig<CreateReportDefinition400>, {reportType: CreateReportDefinitionPathParams["reportType"]}, TContext>
      
}